import React, { Fragment, useContext, useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import CardContext from "../../context/card/CardContext";
import AuthContext from "../../context/auth/AuthContext";
import ConfigContext from "../../context/config/ConfigContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import Card from "./CardItem";
import useTokenCheck from "../../hooks/useTokenCheck";
import usePageTitle from "../../hooks/usePageTitle";

const Cards = (props) => {
  const authContext = useContext(AuthContext);
  const { token, isAuthenticated } = authContext;
  const cardContext = useContext(CardContext);
  const {
    cards,
    loadUserCards,
    isLoading,
    loaded,
    setCurrentCard,
    clearCurrentCard,
    getIndividualContracts,
    error,
  } = cardContext;
  const configContext = useContext(ConfigContext);
  const { getConfigValueByNamePatron } = configContext;
  console.log("In Cards...");
  const history = useHistory();

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Cards",
  });

  useEffect(() => {
    console.log("Auth...", isAuthenticated);
    console.log("Card Error...", error);
    console.log("Card loaded...", loaded);
    if (isAuthenticated && !error && !loaded && !isLoading) {
      console.log("Loading user Cards...");
      loadUserCards({}, token);
    }
    // eslint-disable-next-line
  }, [loaded]);
  const { hasTokenExpired } = useTokenCheck();
  //setCurrentCard
  const selectCurrentCard = async (card, action) => {
    await hasTokenExpired();
    setCurrentCard(card);
    if (action === "show-detail") history.push("/home/mycard-details");
  };
  //setCurrentCard
  const removeCurrentCard = () => {
    clearCurrentCard();
  };

  const [labels, setLabels] = useState({
    serialnumber: "",
  });
  useEffect(() => {
    let serialnumber = getConfigValueByNamePatron(
      "generalConfig",
      "Label",
      "label.serialnumber"
    );
    setLabels({
      ...labels,
      serialnumber,
    });
    //eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      {isLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronHome"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 id="pageHeader" className="patronHome__pageTitle">
          MY METRO Q CARDS
        </h1>
        <div id="menu-card">
          {cards &&
            cards.map(
              (card) =>
                card && (
                  <Card
                    key={card.id}
                    card={card}
                    labels={{
                      SerialNumber: "Serial Number",
                      // SerialNumber: getConfigValue(
                      //   "patronConfig",
                      //   "Label",
                      //   "label.serialnumber"
                      // ),
                    }}
                    setCurrent={selectCurrentCard}
                    clearCurrent={removeCurrentCard}
                    getIndividualContracts={getIndividualContracts}
                  />
                )
            )}
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(Cards);
